module.exports = __webpack_public_path__ + "static/media/bannermob-1.3a0c4308.jpg";